import { amplitudeModule } from '@/modules/amplitude';
import { FacebookModule } from '@/modules/facebook';
import { TikTokModule } from '@/modules/tiktok';
import { webCampaign } from '@/modules/webCampaign';
import {
  StripeV2CoinsPrice,
  StripeV2SubscriptionPrice,
} from '@/services/stripe/dto';

export const sendAnalitycsAfterSubscription = (
  fields: StripeV2SubscriptionPrice,
  coinsPlan?: StripeV2CoinsPrice | null,
  paymentIntentId?: string,
) => {
  amplitudeModule.logEvent('web_purchase', {
    plan: fields.id,
  });

  // Log coins purchase event if coins are included
  if (coinsPlan) {
    amplitudeModule.logEvent('web_purchase', {
      plan: coinsPlan.id,
    });
  }

  TikTokModule.trackEvent(
    'Purchase',
    {
      contents: [
        {
          content_id: fields.id, // string. ID of the product. Example: "1077218".
          content_type: 'product', // string. Either product or product_group.
          content_name: fields.label, // string. The name of the page or product. Example: "shirt".
          price: fields.price, // number. The price of a single item. Example: 25.
          quantity: 1, // number. The number of items. Example: 4.
        },
      ],
      content_type: 'product', // string. Either product or product_group.
      value: fields.price, // number. Value of the order or items sold. Example: 100.
      currency: 'USD', // string. The 4217 currency code. Example: "USD".
      description: 'Payment for subscription', // string. Non-hashed public IP address of the browser.
      ...(paymentIntentId ? { order_id: paymentIntentId } : {}),
    },
    paymentIntentId ? { event_id: paymentIntentId } : undefined,
  );

  if (webCampaign.canLogFBEvents()) {
    FacebookModule.trackEvent('Purchase', {
      value: fields.price,
      currency: 'USD',
    });
    FacebookModule.trackEvent('Subscribe', {
      value: fields.price,
      currency: 'USD',
    });
  }

  // HilltopAds postback
  window.sendHilltopAdsPostback && window.sendHilltopAdsPostback();

  // TrafficStars postback
  window.sendTrafficStarsPostback && window.sendTrafficStarsPostback();
};
